import { render } from "./BracketsCheckIcon.vue?vue&type=template&id=1a96ddae"
import script from "./BracketsCheckIcon.vue?vue&type=script&lang=js"
export * from "./BracketsCheckIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__